import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import AppRouter from './AppRouter.tsx'
import { LicenseProvider } from './lib/LicenseContext'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LicenseProvider>
      <AppRouter />
    </LicenseProvider>
  </StrictMode>,
)
